import debug from "debug";
const log = debug("button-pending-state");

class ButtonPendingState {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		log(element, options);

		this.button = element.closest("button");
		this.controller = this.options.controllerSelector
			? document.querySelector(this.options.controllerSelector)
			: document;

		if (!this.button) {
			log(`Parent button not found. Aborting...`);
			return false;
		}

		if (this.options.controllerSelector && !this.controller) {
			log(
				`Controller element matching "${this.options.controllerSelector}" not found. Aborting...`
			);
			return false;
		}

		this.watch();
	}

	watch() {
		this.controller.addEventListener(
			this.options.enterEvent,
			this.disableButton.bind(this)
		);
		this.controller.addEventListener(
			this.options.exitEvent,
			this.reEnableButton.bind(this)
		);
	}

	disableButton() {
		this.button.classList.add(this.options.pendingClass);
		this.button.addEventListener(
			"click",
			this.handleDisabledClick.bind(this),
			{ capture: true }
		);
	}

	reEnableButton() {
		this.button.classList.remove(this.options.pendingClass);
		this.button.removeEventListener(
			"click",
			this.handleDisabledClick.bind(this),
			{ capture: true }
		);
	}

	handleDisabledClick(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}
}

ButtonPendingState.DEFAULTS = {
	pendingClass: "is--pending",
};

export default ButtonPendingState;



// WEBPACK FOOTER //
// ./client/src/core/components/button-pending-state/button-pending-state.js